<template>
  <div class="mybody">
    <van-nav-bar placeholder title="我的" left-text="" left-arrow >
      <template #right>
      </template>
    </van-nav-bar>
    <div class="my-head">
      <span v-if="user.muserHeader"><img :src="fileDisplayPrefix + user.muserHeader"></span>
      <span v-else><img src="@/assets/myhead.png"></span>
      <h2>{{user.mfullName}}</h2>
    </div>
    <van-cell-group inset>
      <van-cell title="我的纠纷" is-link @click="goToPage(1)" />
      <van-cell title="我的意见" is-link @click="goToPage(2)"/>
      <van-cell title="修改手机号" is-link @click="goToPage(3)"/>
      <van-cell title="账单信息" is-link @click="goToPage(4)"/>
      <van-cell title="切换身份" is-link @click="show = true"/>
      <van-cell title="清理缓存" is-link @click="clear()"/>
    </van-cell-group>

    <van-action-sheet
            v-model="show"
            :actions="actions"
            cancel-text="取消"
            close-on-click-action
            @select="selectedChange"
            @cancel="onCancel"
    />
  </div>
</template>

<script>
  import {FILE_DISPLAY_PREFIX} from "@/api/upload";
  import {getRole} from "@/api/common";
  import Utils from "@/js/common/utils";
  import storage from 'store'
  import {ACCESS_TOKEN} from '@/store/mutation-types'

  export default {
    name: 'my',
    components: {
    },
    data () {
      return {
        show: false,
        actions: [{ name: '家长', value: 1 }],
        fileDisplayPrefix: FILE_DISPLAY_PREFIX
      }
    },
    computed: {
      user () {
        return this.$store.getters.userInfo
      }
    },
    created () {
      this.getRoleList()
    },
    mounted () {
    },
    methods: {
      //获取角色信息
      getRoleList(){
        getRole().then(res => {
          this.actions = res.result;
          // console.log(this.actions, "ssj")
        })
      },
      //1-家长(默认) 2-教培管理 3-教师
      selectedChange (action) {
        // console.log("数据", action);
        Utils.saveLocal("identity",action);
        this.$toast("身份已更改为" + action.name);
        setTimeout(() => {
          location.reload()
        }, 600);
      },
      onCancel() {
        this.show = false
      },
      clear() {
        storage.remove(ACCESS_TOKEN)
        location.replace('/login')
      },
      // 页面跳转 type: 1-纠纷列表页面
      goToPage(type) {
        switch (type) {
          case 1:
            //纠纷列表页面
            this.$router.push({path: `/my/disputeList`});
            break;
          case 2:
            //我的意见
            this.$router.push({path: `/my/ideaList`});
            break;
          case 3:
            this.$router.push({path: `/my/changePhone`});
            break;
          case 4:
            this.$router.push({path: `/my/bill`});
            break;
          default:
        }
      }
    }
  }
</script>

<style scoped>
.mybody{
  background: #f2f6fd;
  height: 100vh;
}
/deep/.van-cell-group{
  display: flex;
  background: #ffffff !important;
  border-radius:12px;
  margin: 0 10px;
  flex-direction: column;
  box-shadow: 0px 3px 40px 0px rgba(0,0,0,0.07);
}
/deep/.van-cell{
  background: none;
}
/deep/.van-cell__title span{

}
.my-head{
  margin:14px 10px;
  height:140px;
  background: url("../../assets/mybg.png") #7DCF8E;
  background-size: 100% 100%;
  border-radius:12px;
  padding:14px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.my-head span{
  display: flex;
  border-radius: 100px;
  width:60px;
  height:60px;
  background: rgba(255,255,255,.8);
  overflow: hidden;
  padding: 4px;
  flex: none;
  flex-grow: 0;
  gap: 10px;
}
.my-head span img{
  width:60px;
  height:60px;
  border-radius: 100px;
}
.my-head h2{
  display: flex;
  font-size: 16px;
  color: #FFFFFF;
  font-weight: bold;
  align-items: center;
  justify-content: center;
  flex: none;
  flex-grow: 0;
  gap: 10px;
  margin-top: 10px;
}
</style>
